<div class="header-navbar">
  <div class="container-max">
    <nav class="navbar navbar-expand-lg">
      <a class="navbar-brand logo" [routerLink]="['/']"></a>

      <div class="navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li
            class="nav-item"
            [class.active]="isHome"
          >
            <a class="nav-link" [routerLink]="['/']"
            ><i class="icon icon-earn"></i>
              <!-- Dashboard  -->
              <!-- <span class="nav-title"> {{'header.navbar.dashboard' | translate}} </span></a> -->
              
              <!-- Reward/Claim Dashboard -->
              <span class="nav-title"> Tokens </span>
            </a>
          </li>

          <!-- <li
            class="nav-item"
            routerLinkActive="active"
          >
            <a class="nav-link" [routerLink]="['/', 'earn']"
            ><i class="icon icon-earn"></i>
              <span class="nav-title">{{'header.navbar.earn' | translate}}</span></a
            >
          </li> -->

          <!-- <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/', 'transactions']"
            ><i class="icon icon-transactions"></i>
              <span class="nav-title">{{'header.navbar.transactions' | translate}}</span></a
            >
          </li> -->

          <!-- <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/', 'live-transactions']"
            ><i class="icomoonclock icon-clock"></i>
              <span class="nav-title">{{'header.navbar.live-transactions' | translate}}</span></a
            >
          </li> -->
        </ul>

        <div class="header-info">
          <div
            class="network-select"
            *ngIf="auth.isLoggedIn && walletService.chainID"
            (click)="changeNetwork()"
            [tooltip]="UserNetworkTooltip" 
          >
            <img [src]="chainIdToImage[walletService.chainID] || ''" alt="">
            <ng-template #UserNetworkTooltip>
              <span>
                {{ chainIdToName[walletService.chainID] }}
              </span>
            </ng-template>
          </div>
          <div class="notification-block">
            <div class="dropdown dropdown-form-control" container="body">
              <button
                class="btn dropdown-toggle"
                type="button"
                id="notification"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                aria-controls="notification-menu"
              >
                <div class="notification-icon">
                  <i class="icon icon-glocke"></i>
                </div>
              </button>

            </div>
          </div>

          <div class="partner header-dropdown-min">
            <app-dropdown
              [classes]="'dropdown dropdown-min'"
              id="currency-dropdown"
              [selected]="{ code: (currentCurrency$ | async) }"
              [items]="currencies"
              (selectedChange)="changeCurrency($event)"
              nameProp="code"
              valueProp="code"
            >
              <ng-template
                #buttonTemplate
                let-id="id"
                let-nameProp="nameProp"
                let-selected="selected"
              >
                <button
                  class="btn dropdown-toggle"
                  type="button"
                  [id]="id + '-toggle'"
                  data-toggle="dropdown"
                  data-flip="false"
                  data-display="static"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span class="btn-toggle dropdown-item dropdown-item-lender">
                    {{ selected[nameProp] }}
                  </span>
                </button>
              </ng-template>

              <ng-template
                #optionTemplate
                let-item
                let-select="select"
                let-selected="selected"
                let-nameProp="nameProp"
                let-valueProp="valueProp"
              >
                <span
                  class="btn-toggle dropdown-item dropdown-item-lender"
                  [class.active]="selected[valueProp] === item[valueProp]"
                  [class.active-default]="
                    selected[valueProp] === item[valueProp]
                  "
                  [attr.data-status]="item[valueProp]"
                  (click)="select(item)"
                >
                  {{ item[nameProp] }}
                </span>
              </ng-template>
            </app-dropdown>
          </div>
          <div class="profile-logo" *ngIf="auth.isLoggedIn; else tokenButton">
            <div
              class="dropdown dropdown-form-control ml-2"
              placement="bottom right"
            >
              <button
                class="btn dropdown-toggle"
                type="button"
                id="profile-logo"
                data-toggle="dropdown"
                data-target="#profile-menu"
                aria-haspopup="true"
                aria-expanded="false"
                aria-controls="profile-menu"
              >
                <div
                  class="profile-logo-img"
                  [class.profile-upload]="(userAvatar$ | async) === null"
                  >
                  <img [src]="userAvatar$ | async" class="imgshow"/>
                </div>
              </button>

              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="profile-logo"
                id="profile-menu"
              >
                <ul class="profile-menu">
                  <li class="profile-menu-header">
                    <div
                      class="profile-logo-img"
                      [class.profile-upload]="
                      (userAvatar$ | async) === null
                      "
                    >
                      <img [src]="userAvatar$ | async" class="imgshow"/>
                    </div>
                    <div class="profile-name" *ngIf="auth.userData.username">
                      <div class="profile-email">
                        {{
                          auth.userData.username.slice(0, 7)
                          +'...'+
                          auth.userData.username.slice(-5)
                        }}
                      </div>
                    </div>
                  </li>

                  <li
                    [routerLink]="['/', 'profile']"
                    class="cursor-pointer"
                  >
                    <a
                    ><span
                    ><i class="icomoonfm3 icomoonfm3-user"></i>{{'header.dropdown-navbar.profile' | translate}}</span
                    ></a
                    >
                  </li>

                  <li
                    routerLink (click)="toReferralPage()"
                    class="cursor-pointer"
                  >
                    <a
                    ><span
                    ><i class="iconfm icomoonfm-users"></i>{{'header.dropdown-navbar.referrals' | translate}}</span
                    ></a>
                  </li>
                  <li class="cursor-pointer">
                    <a href="https://coindepo.io/support/help-center"
                        target="_blank"
                    ><span
                    ><i class="icomoonfm3 icomoonfm3-question"></i>{{'header.dropdown-navbar.help-center' | translate}}</span
                    ></a
                    >
                  </li>

                  <li (click)="logout()" class="cursor-pointer">
                    <a
                    ><span
                    ><i class="iconfm icomoonfm-log"></i>{{'header.dropdown-navbar.log-out' | translate}}</span
                    ></a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
            <ng-template #tokenButton>
              <button
                (click)="startAuth()"
                type="button"
                class="btn btn-secondary btn-lg ml-20 connect-your-wallet"
                [innerHTML]="'shared.connect-you-wallet' | translate"
              >
              </button>
            </ng-template>
          <!-- .profile-logo -->
        </div>
        <!-- .header-info -->
      </div>
    </nav>
  </div>
</div>
